import { render, staticRenderFns } from "./Discharge.vue?vue&type=template&id=24b02630&"
import script from "./Discharge.vue?vue&type=script&lang=ts&"
export * from "./Discharge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24b02630')) {
      api.createRecord('24b02630', component.options)
    } else {
      api.reload('24b02630', component.options)
    }
    module.hot.accept("./Discharge.vue?vue&type=template&id=24b02630&", function () {
      api.rerender('24b02630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/ward/Discharge.vue"
export default component.exports